import { toJS } from "mobx";
import { useObserver } from "mobx-react";
import React, { useContext, useEffect, useState } from "react";
import Overlay from "../../../common/Overlay";
import { Store } from "../../../state/state";

function SaveCalendar({ onClose, open }) {
  const store = useContext(Store);
  const [categories, setCategories] = useState([
    "عادي",
    "مدارس",
    "جامعات",
    "مبرمجين",
  ]);
  const [category, setCategory] = useState();

  const onSave = async () => {
    let theme = toJS(store.theme);
    let contentTheme = JSON.stringify(theme);
    let file = new Blob([contentTheme], { type: "json" });
    var element = document.createElement("a");

    element.setAttribute("href", URL.createObjectURL(file));
    element.setAttribute("download", theme.name + ".json");

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
    onClose();
  };
  return useObserver(() => (
    <div>
      <label htmlFor="name">اسم</label>
      <input
        type="text"
        className="border shadow p-2 rounded mx-2"
        value={store.theme.name}
        onChange={(e) => (store.theme.name = e.target.value)}
      />
      <label htmlFor="group">المجموعة</label>
      <select
        value={store.theme.category}
        onChange={(e) => {
          store.theme.category = e.target.value;
        }}
        name="group"
        id=""
        className="border shadow p-2 rounded mx-2"
      >
        <option value="">اختر المجموعة</option>
        {categories.map((data) => (
          <option key={data} value={data}>
            {data}
          </option>
        ))}
      </select>

      <button
        disabled={category === ""}
        onClick={onSave}
        className={
          "bg-blue-500 px-5 py-2 hover:bg-blue-600 cursor-pointer rounded shadow mt-5 text-white"
        }
      >
        حفظ
      </button>
    </div>
  ));
}

export default Overlay(SaveCalendar);
